export default __webpack_public_path__ + "static/media/BLUEnet Door Controller.731b1b52.jpg";